export const COLORS = [
  "#2B7A0B",
  "#3B44F6",
  "#F9D923",
  "#EB5353",
  "#E59934",
  "#B051B7"
];

export const WITHOUT_HASHTAG = { id: -1, name: "فاقد هشتگ", color: null };

export const REPORT_TYPES = {
  ACTIVITY: "ACTIVITY",
  REVIEW: "REVIEW",
  DETAIL_REVIEW: "DETAIL_REVIEW"
};
